import { Button, ButtonProps } from '@mui/material';
import { TDoc } from 'shared/model';
import { useRemoveDocuments } from 'shared/_model/docs/components/RemoveDocumentsMenuItem';

type Props = Omit<ButtonProps, 'onClick' | 'children' | 'action'> & {
	docs: Pick<TDoc, '_id'>[];
	action: Parameters<typeof useRemoveDocuments>[1];
	callback?: () => unknown;
};

/** `Delete (N)` button: asks for confirmation and removes the documents. Hidden when removing is not allowed. */
export default function RemoveDocumentsButton({
	docs,
	action,
	callback,
	disabled,
	...buttonProps
}: Props) {
	const { removeDocumentAllowed, runRemoveDocument } = useRemoveDocuments(docs, action, callback);

	if (!removeDocumentAllowed) {
		return null;
	}

	return (
		<Button {...buttonProps} disabled={disabled || !docs.length} onClick={runRemoveDocument}>
			Delete
		</Button>
	);
}
